import { createContext, useContext, useEffect, useState } from 'react';

export interface LoadingContextData {
    upperMetricsIsLoading: boolean;
    dataBlockIsLoading: boolean;
    isToUpdateAll: boolean;
    setDataBlockIsLoading: (value: boolean) => void;
    setUpperMetricsIsLoading: (value: boolean) => void;
    setIsToUpdateAll: (value: boolean) => void;
}

interface LoadingContextValue {
    children: any;
}

export const LoadingContext = createContext<LoadingContextData | undefined>(undefined);

export const LoadingProvider: React.FC<LoadingContextValue> = ({ children }) => {
    const [upperMetricsIsLoading, setUpperMetricsIsLoading] = useState<boolean>(false);
    const [dataBlockIsLoading, setDataBlockIsLoading] = useState<boolean>(false);
    const [isToUpdateAll, setIsToUpdateAll] = useState<boolean>(false);

    useEffect(() => {
        setIsToUpdateAll(false);
    }, [upperMetricsIsLoading, dataBlockIsLoading]);

    return (
        <LoadingContext.Provider
            value={{
                upperMetricsIsLoading,
                setUpperMetricsIsLoading,
                dataBlockIsLoading,
                setDataBlockIsLoading,
                isToUpdateAll,
                setIsToUpdateAll,
            }}
        >
            {children}
        </LoadingContext.Provider>
    );
};

export function useLoadingContext(): LoadingContextData {
    const context = useContext(LoadingContext);

    if (!context) {
        throw new Error('useLoadingContext must be used within a LoadingProvider');
    }
    return context;
}
